import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface UseGoogleLoginReturn {
  googleLoginUrl: string;
  pathname: string;
  setLocaleIntoSession: () => void;
}

const useGoogleLogin = (): UseGoogleLoginReturn => {
  const router = useRouter();
  const isDefaultLocale = router.locale === router.defaultLocale;
  const pathname = router.asPath;
  const googleLoginUrl = isDefaultLocale ? '/auth/login/google-oauth2/' : `/${router.locale}/auth/login/google-oauth2/`;

  useEffect(() => {
    const subPath = (window as any).sessionStorage.getItem('sub_path');
    if (subPath) {
      router.push(router.pathname, router.asPath, { locale: subPath });
      (window as any).sessionStorage.removeItem('sub_path');
    }
  }, [router]);

  const setLocaleIntoSession = () => {
    if (!isDefaultLocale) {
      (window as any).sessionStorage.setItem('sub_path', router.locale);
    }
  };

  return { googleLoginUrl, pathname, setLocaleIntoSession };
};
export default useGoogleLogin;
